module.exports = __webpack_public_path__ + "media/images/icons/icons_small/35_heartbaloons-5f77e4623089e1d00fe54139fc93e40c.png";